import { Button, Grid } from "@material-ui/core";
import { WHITE } from "../../utils/const";

const ProjectSettings = ({ types, tags, devices, project }) => {
  const styles = {
    container: { padding: "5px 15px", margin: "10px auto" },
  };
  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.container}>
        <Button
          variant="contained"
          color="primary"
          style={{ color: WHITE }}
          // onClick={() => openModal(1)}
        >
          ویرایش پروژه
        </Button>
        <Button
          variant="contained"
          color="secondary"
          style={{ color: WHITE, margin: "0 10px" }}
          // onClick={() => openModal(2)}
        >
          تنظیمات پروژه
        </Button>
      </Grid>
    </>
  );
};
export default ProjectSettings;
